const modalHeader = {
  render({ text }) {
    return `
      <div class="modal__header">
        <h2 class="headline3">${text}</h2>
      </div>
    `
  },
}

export default modalHeader
